import houseExpropriation from '@/page/house-expropriation'
import regulations from '@/page/regulations/index'
import regulationsDetail from '@/page/regulations/regulationsDetail'
import incident from '@/page/incident/index'
import incidentDetail from '@/page/incident/incidentDetail'
import theme from '@/page/theme/index'
import themeDetail from '@/page/theme/themeDetail'
import articles from '@/page/articles/index'
import articlesDetail from '@/page/articles/articlesDetail'
import projectList from '@/page/projectList/index'
import projectIndex from '@/page/project-system/index'
import projectnews from '@/page/project-system/projectnews/index'
import projectnewsDetail from '@/page/project-system/projectnews/projectnews-detail'
import announcement from '@/page/project-system/announcement/index'
import announcementDetail from '@/page/project-system/announcement/announcement-detail'
import personal from '@/page/project-system/personal/index'
import personalDetail from '@/page/project-system/personal/personal-detail'
import selection from '@/page/project-system/selection/index'
import see from '@/page/project-system/see/see'
import xian from '@/page/project-system/see/selection-detail'
import selectionDetail from '@/page/project-system/selection/selection-detail'
import housingEstateDetail from '@/page/project-system/selection/housing-estate-detail'
import program from '@/page/project-system/program/index'

export default [
  {
    path: '/public',
    name: 'public',
    component: houseExpropriation
  },
  {
    path: '/news',
    name: 'News',
    component: regulations
  },
  {
    path: '/news/detail',
    name: 'regulationsDetail',
    component: regulationsDetail
  },
  {
    path: '/incident',
    name: 'incident',
    component: incident
  },
  {
    path: '/incident/detail',
    name: 'incidentDetail',
    component: incidentDetail
  },
  {
    path: '/theme',
    name: 'theme',
    component: theme
  },
  {
    path: '/theme/themeDetail',
    name: 'themeDetail',
    component: themeDetail
  },
  {
    path: '/articles',
    name: 'articles',
    component: articles
  },
  {
    path: '/articles/articlesDetail',
    name: 'articlesDetail',
    component: articlesDetail
  },
  {
    path: '/projectlist',
    name: 'projectlist',
    component: projectList
  },
  {
    path: '/projecthome',
    name: 'projecthome',
    component: projectIndex
  },
  {
    path: '/projectnews',
    name: 'projectnews',
    component: projectnews
  },
  {
    path: '/projectnewsdetail',
    name: 'projectnewsDetail',
    component: projectnewsDetail
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: announcement
  },
  {
    path: '/announcementdetail',
    name: 'announcementdetail',
    component: announcementDetail
  },
  {
    path: '/personal',
    name: 'personal',
    component: personal
  },
  {
    path: '/personaldetail',
    name: 'personaldetail',
    component: personalDetail
  },
  {
    path: '/selection',
    name: 'selection',
    component: selection
  },
  {
    path: '/see',
    name: 'see',
    component: see
  },
  {
    path: '/xian',
    name: 'xian',
    component: xian
  },
  {
    path: '/selectionDetail',
    name: 'selectionDetail',
    component: selectionDetail
  },
  {
    path: '/housingEstateDetail',
    name: 'housingEstateDetail',
    component: housingEstateDetail
  },
  {
    path: '/program',
    name: 'program',
    component: program
  }
];



// WEBPACK FOOTER //
// ./src/router/application.js